<template>
    <b-link
            v-if="Boolean(website)"
            class="service-provider-card-website"
            :href="website"
            target="_blank"
    >
        {{ shortenUrl(website) }}
    </b-link>
</template>

<script>
    import ServiceProviderAppResource
        from "@milestoneslabs/milestones-core-js/src/AppResources/ServiceProviderAppResource";
    import {addProtocol, shortenUrl} from "../../../../helpers/url";


    export default {
        name: "ServiceProviderCardWebsite",
        props: {
            serviceProvider: {
                type: ServiceProviderAppResource,
                required: true
            }
        },
        computed: {
            website() {
                if (!Boolean(this.serviceProvider.hasContact)) {
                    return addProtocol(this.serviceProvider.website);
                }
                if (Boolean(this.serviceProvider.contactWebsite)) {
                    return addProtocol(this.serviceProvider.contactWebsite);
                }
                return addProtocol(this.serviceProvider.website);
            }
        },
        methods: {
            shortenUrl,
        }
    };
</script>